<template>
  <div>
    <BaseLoading
      v-if="isLoading"
      full-screen
    />
    <BaseLoading v-if="isCheckLoading" />
    <template v-else>
      <template v-if="isHashInvalid">
        <div class="p-2 mt-4 text-center">
          <BaseTextH2>{{ $t('we-are-unable-to-process-your-request-with-provided-parameters') }}</BaseTextH2>
        </div>
      </template>
      <template v-else>
        <div class="p-2 pt-4">
          <div class="pt-4">
            <b-form-checkbox
              v-model="isRoundEmailsAllowed"
              :value="true"
              :unchecked-value="false"
            >
              {{ $t('email-round-notifications') }}
            </b-form-checkbox>
          </div>

          <b-form-checkbox
            v-model="isPromoEmailsAllowed"
            :value="true"
            :unchecked-value="false"
          >
            {{ $t('email-promo-notifications') }}
          </b-form-checkbox>

          <BaseButton
            is-rounded
            class="d-block my-4 pt-4"
            @click="handleSubmit"
          >
            {{ $t('set-my-email-preferences') }}
          </BaseButton>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseLoading from '@/components/Atoms/BaseLoading'
import { buildNotification } from '@/helpers/ui'
import BaseTextH2 from '@/components/Atoms/Typography/BaseTextH2'

export default {
  components: {
    BaseTextH2,
    BaseLoading,
    BaseButton,
  },
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  metaInfo() {
    return {
      title: this.$t('page-titles.unsubscribe'),
    }
  },
  data() {
    return {
      hash: this.$route.params.hash,
      isHashInvalid: false,
      isCheckLoading: false,
      isLoading: false,
      isPromoEmailsAllowed: true,
      isRoundEmailsAllowed: true,
    }
  },
  async created() {
    try {
      this.isCheckLoading = true
      const check = await axios.get(`profile/getEmailPreferences/${this.hash}`)
      this.isPromoEmailsAllowed = !!check.user.is_promo_emails_allowed
      this.isRoundEmailsAllowed = !!check.user.is_round_emails_allowed
      this.isCheckLoading = false
    } catch (err) {
      this.isHashInvalid = true
      this.isCheckLoading = false
    }
  },
  methods: {
    async handleSubmit() {
      try {
        this.isLoading = true
        await axios.post(`profile/setEmailPreferences`, {
          hash: this.hash,
          isPromoEmailsAllowed: this.isPromoEmailsAllowed,
          isRoundEmailsAllowed: this.isRoundEmailsAllowed,
        })
        this.isLoading = false
        buildNotification({
          title: this.$t('your-email-preferences-was-updated'),
        })
      } catch ({ error }) {
        this.isLoading = false
        buildNotification({
          title: this.$t('an-error-occurred-while-saving-your-email-preferences'),
          progressBarColor: '#f03c25',
        })
      }
    },
  },
}
</script>
